import {
  Schema,
  entityId,
  entityType,
  rights,
  tripId,
  userId,
  shareableId,
} from './common_schema.js';

const kCheckedState = 'checked';
const kGeneratedState = 'generated';
const kState = [kCheckedState, kGeneratedState];

const id = Schema.Int;
const parentId = Schema.Or(Schema.Int, null);
const idx = Schema.Int;
const name = Schema.String;
const state = Schema.Set(...kState);

const diff = Schema.Array(
  Schema.Object({
    what: Schema.OptionalEnum('changed', 'deleted', 'inserted', 'shifted'),
    id: Schema.Optional(id),
    idx: Schema.Optional(idx),
    parentId: Schema.Optional(parentId),
    state,
    name,
    get children() {
      return Schema.Optional(diff);
    },
  })
);

const schemaFields = {
  tripId,
  entityId,
  entityType,
  id,
  parentId,
  idx,
  name,
  state,
  userId,
  shareableId,
  rights,
};

const schema = {
  'get-items': new Schema({
    entityId,
  }),
  'update-items': new Schema({
    entityId,
    diff,
  }),
  'pack-gear': new Schema({
    entityId,
    list: Schema.Array(
      Schema.Object({
        id,
        checked: Schema.Boolean,
      })
    ),
  }),
};

export {
  kGeneratedState,
  kCheckedState,
  kState,
  schema as ChecklistSchema,
  schemaFields as ChecklistSchemaFields,
};
